import { getPath } from '@/router/common'

const baseUrl = {
  title: '导入模板',
  path: 'NewWarehouseManagement'
}
export default [
  {
    path: getPath('NewWarehouseTemplate', baseUrl),
    name: 'NewWarehouseTemplate',
    component: () => import(/* webpackChunkName: "NewWarehouseTemplate" */ '@/views/newWarehouseManagement/newWarehouseTemplate/index.vue'),
    meta: {
      title: '导入模板'
    }
  },
  {
    path: getPath('NewWarehouseTemplateEdit', baseUrl),
    name: 'NewWarehouseTemplateEdit',
    component: () => import(/* webpackChunkName: "NewWarehouseTemplateEdit" */ '@/views/newWarehouseManagement/newWarehouseTemplateEdit/index.vue'),
    meta: {
      title: '新增模板'
    }
  }
]
